import { createAsyncThunk } from '@reduxjs/toolkit';
import request from '../../request/request';

export const getTenantCourseDetail = createAsyncThunk('tenantCourseDetail', async (params = {}, { rejectWithValue }) => {
  let url = '/api/v1/tenant-list';
  if (params.id) {
    url += `/${params.id}`;
  }
  if (params.search && params.searchText) {
    url += `?search=${encodeURIComponent(params.searchText)}`;
  }
  if (params.length) {
    url += `?${params.join('&')}`;
  }
  const response = await request(url, { method: 'GET', auth: true });

  if (response?.data) {
    return response;
  }
  const { error } = response;
  throw rejectWithValue(error || 'Something went wrong');
});